import type { ChannelNumberType } from '@/services/domain/senderSettings/senderChannelTypes'
import { AppModule } from '@/config/types'

export const CHANNEL_TO_MODULE: Record<ChannelNumberType, AppModule> = {
  whatsApp: AppModule.WhatsApp,
  widgets: AppModule.WebWidgets,
  facebook: AppModule.Facebook,
  instagram: AppModule.Instagram,
}
